import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, StaffAutoComplete } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteStaffProps {
  isCoach?: boolean;
  search: string;
  loginEnabledFilter?: boolean;
}

function useAutoCompleteStaff({
  isCoach,
  search,
  loginEnabledFilter,
}: IUseAutoCompleteStaffProps): UseQueryResult<{ data: Array<StaffAutoComplete> }> {
  const params: UrlParams = {};
  if (!!isCoach) {
    params.is_coach = isCoach ? 'True' : 'False';
  }
  if (search) {
    params.search = search;
  }

  if (loginEnabledFilter) {
    params.profile__login_enabled = loginEnabledFilter ? 'True' : 'False';
  }

  return useQuery(['staff-autocomplete', isCoach, search, loginEnabledFilter], () =>
    client.get(`staff/auto-complete/?${encodeUrlParams(params)}`),
  );
}

export default useAutoCompleteStaff;
